<template>
  <el-container class="app-container">
    <!-- 侧边栏 -->
    <el-aside width="200px">
      <div class="logo"><img src="@/assets/logo.png"  />血糖数据分析系统</div>
      <el-menu :default-active="activeMenu" background-color="#304156" text-color="#bfcbd9" active-text-color="#409EFF"
        router>
        <el-menu-item index="/dashboard">
          <i class="el-icon-s-home"></i>
          <span slot="title">首页</span>
        </el-menu-item>
        <el-menu-item index="/doctor/patient" v-if="role == 'doctor'">
          <i class="el-icon-user"></i>
          <span slot="title">患者列表</span>
        </el-menu-item>
        <el-menu-item index="/report/list" v-if="role == 'doctor'">
            <i class="el-icon-document-checked"></i>
            <span slot="title">报告列表 <span class="bot" v-if="count != '0'">{{  count }}</span></span>
        </el-menu-item>
        <el-menu-item index="/glucose/dashboard" v-if="role == 'doctor'">
            <i class="el-icon-help"></i>
            <span slot="title">数据看板</span>
        </el-menu-item>
        <el-menu-item index="/doctor/group" v-if="role == 'doctor'">
          <i class="el-icon-price-tag"></i>
          <span slot="title">分组二维码</span>
        </el-menu-item>
        <el-menu-item index="/doctor/tag" v-if="role == 'doctor'">
            <i class="el-icon-s-flag"></i>
            <span slot="title">标签管理</span>
        </el-menu-item>
        <el-menu-item index="/doctor/notification" v-if="role == 'doctor'">
            <i class="el-icon-s-opportunity"></i>
            <span slot="title">通知列表</span>
        </el-menu-item>
        <el-menu-item index="/doctor/export" v-if="role == 'doctor'">
            <i class="el-icon-download"></i>
            <span slot="title">数据导出</span>
        </el-menu-item>

        <!-- 添加基本管理菜单 -->
        <el-submenu index="/basic" v-if="role == 'admin'">
          <template slot="title">
            <i class="el-icon-s-tools"></i>
            <span>基本管理</span>
          </template>
          <el-menu-item index="/basic/hospital">
            <i class="el-icon-office-building"></i>
            <span slot="title">医院管理</span>
          </el-menu-item>
          <el-menu-item index="/basic/patient">
            <i class="el-icon-user"></i>
            <span slot="title">患者管理</span>
          </el-menu-item>
          <el-menu-item index="/basic/patientGroup">
            <i class="el-icon-copy-document"></i>
            <span slot="title">患者组管理</span>
          </el-menu-item>
        </el-submenu>

        <el-submenu index="/form-manage" v-if="role == 'admin'">
          <template slot="title">
            <i class="el-icon-document-copy"></i>
            <span>表单管理</span>
          </template>
          <el-menu-item index="/form-manage/list">
            <i class="el-icon-document"></i>
            <span slot="title">表单列表</span>
          </el-menu-item>
          <el-menu-item index="/form-manage/records">
            <i class="el-icon-document"></i>
            <span slot="title">表单填写记录</span>
          </el-menu-item>
        </el-submenu>


      </el-menu>
    </el-aside>

    <el-container>
      <!-- 头部 -->
      <el-header>
        <div class="header-left">
          <!-- TagsView组件 -->
          <tags-view />
        </div>
        <div class="header-right">
          <el-dropdown trigger="click">
            <span class="user-info">
              <el-icon class="el-icon-s-custom"></el-icon>
              {{ username }}_{{ role == 'admin' ? '管理员' : '医生' }}
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item @click.native="()=>{$router.replace('/user/resetpassword')}">修改密码</el-dropdown-item>
              <el-dropdown-item v-if="role == 'doctor'" @click.native="()=>{$router.replace('/user/signature')}">设置签名</el-dropdown-item>
              <el-dropdown-item divided @click.native="logout">退出登录</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </el-header>

      
     

      <!-- 主要内容区 -->
      <el-main>
        <keep-alive exclude="DashboardView,ReportList,GlucoseDashboard,NotificationList">
          <router-view :key="$route.fullPath" />
        </keep-alive>
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
import { Store } from '@/utils/LocalCache'
import TagsView from '@/components/TagsView'
export default {
  name: 'Layout',
  components: {
    TagsView
  },
  data() {
    return {
      isPolling: false,
      pollingInterval: 5000,
      polledData: [],
      error: null,
      worker: null,
      workerScript: null,
      count: 0,
    }
  },
  watch: {
    pollingInterval() {
      if (this.pollingInterval < 1000) {
        this.pollingInterval = 1000; // 最小间隔1秒
      }
      this.updateInterval();
    },
    refreshCount: {
      handler(val) {
        if(val && !this.isPolling){
          this.startPolling();
        }
      },
      deep: true
    }
  },
  computed: {
    username() {
      return  Store.get('access_user') ? Store.get('access_user').name : ''
    },
    role() {
      return Store.get('access_role') || this.$store.state.user.role; 
    },
    activeMenu() {
      return this.$route.path
    },
    refreshCount() {
      return this.$store.state.user.refreshCount
    }
  },
  mounted() {
    this.initWorker();
    this.startPolling();
  },
  methods: {
    logout() {
      this.$store.commit('user/RESET_STATE')
      this.$store.dispatch('tagsView/resetVisitedViews')
      this.$router.push('/login')
    },

    initWorker() {
      // 创建Web Worker的代码
      const baseUrl = location.origin;
      const token = localStorage.getItem('access_token');
      const workerCode = `
          let pollingIntervalId = null;
          let interval = 5000; // 默认5秒
          const fetchData = async () => {
            try {
              const result =  fetch('${baseUrl}/api/doctor/report/waiting/count', {
                method: 'GET',
                headers: {
                  'Content-Type': 'application/json',
                  'Authorization': 'Bearer ' + ${token}
                }
              }).then(res => res.json()).then(res => {
                  return res;
              })
            
              const response = await result;
              
              if(response.code != 0){
                return {
                  success: false,
                  error: response.msg || '获取数据时发生错误'
                };
              }
              
              return {
                success: true,
                data: response.data,
                timestamp: new Date().toISOString()
              };
            } catch (error) {
              return {
                success: false,
                error: error.message || '获取数据时发生错误'
              };
            }
          };
          
          self.addEventListener('message', async (event) => {
            const { type, data } = event.data;
            
            switch (type) {
              case 'START_POLLING':
                interval = data.interval || 5000;
                if (pollingIntervalId) {
                  clearInterval(pollingIntervalId);
                }
                // 立即执行一次
                const initialResult = await fetchData();
                self.postMessage(initialResult);

                // 设置定时轮询
                pollingIntervalId = setInterval(async () => {
                  const result = await fetchData();
                  if(result.success == true){
                     if(result.data == '0'){
                      self.postMessage(result);
                        if (pollingIntervalId) {
                          clearInterval(pollingIntervalId);
                          pollingIntervalId = null;
                        }
                        self.postMessage({ type: 'POLLING_STOPPED' });
                     }else{
                      self.postMessage(result);
                    }
                  }
                  
                }, interval);
                break;
                
              case 'STOP_POLLING':
                if (pollingIntervalId) {
                  clearInterval(pollingIntervalId);
                  pollingIntervalId = null;
                }
                self.postMessage({ type: 'POLLING_STOPPED' });
                break;
                
              case 'UPDATE_INTERVAL':
                interval = data.interval;
                if (pollingIntervalId) {
                  // 如果正在轮询，重新启动以应用新的间隔
                  clearInterval(pollingIntervalId);
                  pollingIntervalId = setInterval(async () => {
                    const result = await fetchData();
                    self.postMessage(result);
                  }, interval);
                }
                break;
            }
          });
        `;

      // 创建Blob URL用于Worker
      const workerBlob = new Blob([workerCode], { type: 'application/javascript' });
      this.workerScript = URL.createObjectURL(workerBlob);
    },
    startPolling() {
      this.error = null;
      this.isPolling = true;

      // 创建Web Worker
      this.worker = new Worker(this.workerScript);

      // 处理Worker消息
      this.worker.onmessage = (event) => {
        const { success, data, timestamp, error, type } = event.data;

        if (type === 'POLLING_STOPPED') {
          this.isPolling = false;
          return;
        }

        if (success) {
          this.count = data;
          if(this.count == '0'){
            this.$store.dispatch('user/refreshCount', false)
          }

        } else {
          this.error = error;
          this.stopPolling()
        }
      };

      // 启动轮询
      this.worker.postMessage({
        type: 'START_POLLING',
        data: { interval: this.pollingInterval }
      });
    },

    stopPolling() {
      if (this.worker) {
        this.worker.postMessage({ type: 'STOP_POLLING' });
        this.worker.terminate();
        this.worker = null;
      }
      this.isPolling = false;
    },

    updateInterval() {
      if (this.worker && this.isPolling) {
        this.worker.postMessage({
          type: 'UPDATE_INTERVAL',
          data: { interval: this.pollingInterval }
        });
      }
    },
  },
  beforeDestroy() {
    this.stopPolling();
  }
}
</script>

<style lang="less" scoped>
.app-container {
  height: 100vh;

  .el-menu {
    border: none;
    text-align: left;
  }

  .el-aside {
    background-color: #304156;
    color: #fff;

    .logo {
      height: 60px;
      line-height: 60px;
      text-align: center;
      font-size: 18px;
      font-weight: bold;
      color: #fff;
      background-color: #2b3649;
      img{
        width: 25px;
        height: 25px;
        margin-right: 5px;
        vertical-align: middle;
        margin-bottom: 4px;
      }
    }
  }

  .el-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: #fff;
    color: #333;
    border-bottom: 1px solid #e6e6e6;

    .header-left {
      display: flex;
      align-items: center;
      flex: 1;
      text-align: left;

      .toggle-button {
        margin-right: 15px;
        font-size: 20px;
        cursor: pointer;
      }
    }

    .header-right {
      .user-info {
        display: flex;
        align-items: center;
        cursor: pointer;

        i {
          margin-right: 5px;
        }
      }
    }
  }

  .el-main {
    background-color: #f0f2f5;
    padding: 10px;
    height: calc(100vh - 95px); /* 减去header和tagsView的高度 */
    overflow-y: auto;
  }
}
.bot{
  display: inline-block;
  background-color: #F56C6C;
  color: #fff;
  border-radius: 10px;
  text-align: center;
  line-height: 15px;
  font-size: 12px;
  margin-left: 5px;
  padding: 1px 6px 0;
  margin-top: -3px;
}
</style>